import {
  LaptopOutlined,
  NotificationOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LeftOutlined,
} from '@ant-design/icons';
import { getDirectusClient } from '../lib/directus';
import {
  Layout,
  Menu,
  theme,
  Button,
  Flex,
  Tooltip,
  Avatar,
  Space,
  Image,
} from 'antd';
import React, { useEffect, useState, useMemo } from 'react';

import { Link, useNavigate, useLocation } from 'react-router-dom';
import Validorligin from './Validorligin';
import { useDispatch, useSelector } from 'react-redux';
import { menuAdd } from '../features/menu/menuSlice';
import { readMe } from '@directus/sdk';
import { LogoutOutlined } from '@ant-design/icons';
import moment from 'moment';
import getIconByName from './getIconByName';
import { useCajaStatus } from '../hooks/useCajaStatus';
const { Header, Content, Footer, Sider } = Layout;

const items2 = [UserOutlined, LaptopOutlined, NotificationOutlined].map(
  (icon, index) => {
    const key = String(index + 1);
    return {
      key: `sub${key}`,
      icon: React.createElement(icon),
      label: `subnav ${key}`,
      children: new Array(4).fill(null).map((_, j) => {
        const subKey = index * 4 + j + 1;
        return {
          key: subKey,
          label: `option${subKey}`,
        };
      }),
    };
  }
);

const Layouts = props => {
  const userdata = useSelector(state => state.userdata);
  const [menulist, setMenulist] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menu = useSelector(state => state.menu);
  useCajaStatus();
  const [currentMenuLabel, setCurrentMenuLabel] = useState('');
  const location = useLocation();

  useEffect(() => {
    const getMenu = async () => {
     

      // Verificar si ya tenemos los menús en Redux para evitar peticiones innecesarias
      if (menu && menu.length > 0) {
       
        return;
      }

      const directus = await getDirectusClient();
      try {
        const d = await directus.request(
          readMe({
            fields: [
              'role.menus.menu_id.id',
              'role.menus.menu_id.label',
              'role.menus.menu_id.slug',
              'role.menus.menu_id.iconv',
              'role.menus.menu_id.espadre',
              'role.menus.menu_id.children.id',
              'role.menus.menu_id.children.label',
              'role.menus.menu_id.children.slug',
              'role.menus.menu_id.children.iconv',
            ],
          })
        );
        setMenulist(d.role.menus || []);
      

        dispatch(menuAdd(d.role.menus || []));
      } catch (err) {
        console.error('Error cargando menús:', err);
      }
    };

    if (userdata) {
      getMenu();
    }
  }, [userdata, dispatch, menu]);

  useEffect(() => {
    const getCurrentMenuLabel = () => {
      const currentPath = location.pathname;

      for (const menuItem of menu) {
        if (menuItem?.menu_id?.slug === currentPath) {
          return menuItem.menu_id.label;
        }

        if (menuItem?.menu_id?.children) {
          const subMenuItem = menuItem.menu_id.children.find(
            child => child.slug === currentPath
          );
          if (subMenuItem) {
            return subMenuItem.label;
          }
        }
      }
      return '';
    };

    setCurrentMenuLabel(getCurrentMenuLabel());
  }, [location.pathname, menu]);

  const menuRender = useMemo(
    () =>
      menu.map(menu => {
        return menu?.menu_id?.espadre ? (
          menu.menu_id.children.length > 0 ? (
            <Menu.SubMenu
              icon={getIconByName(menu.menu_id.iconv)}
              key={menu.menu_id.id}
              title={menu.menu_id.label}
            >
              {menu.menu_id.children.map(chil => (
                <Menu.Item icon={getIconByName(chil.iconv)} key={chil.id}>
                  <Link to={chil.slug}>{chil.label}</Link>
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ) : (
            <Menu.Item
              icon={getIconByName(menu.menu_id.iconv)}
              key={menu.menu_id.id}
            >
              <Link to={menu.menu_id.slug}>{menu.menu_id.label}</Link>
            </Menu.Item>
          )
        ) : null;
      }),
    [menu]
  );

  const cerrarSesion = useMemo(
    () => async () => {
      try {
        const directus = await getDirectusClient();
        await directus.logout();

        dispatch(menuAdd([]));
        navigate('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error);
      }
    },
    [navigate]
  );

  const handleGoBack = () => {
    navigate(-1);
  };

  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Validorligin />
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          onCollapse={value => setCollapsed(value)}
          style={{
            background: '#fff',
            borderRight: '1px solid rgba(0, 0, 0, 0.06)',
            height: '100vh',
            position: 'fixed',
            left: 0,
            zIndex: 1000,
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              height: 32,
              margin: 16,
              background: '#fff',
              textAlign: 'center',
            }}
          >
            <Image
              style={{ textAlign: 'center' }}
              width={60}
              src="https://backend.emesmart.com/assets/bd0445d3-40e7-45b6-b284-72f01233f6dc"
            />
          </div>
          <Menu mode="inline">{menuRender}</Menu>
        </Sider>
        <Layout
          style={{ marginLeft: collapsed ? 80 : 200, transition: 'all 0.2s' }}
        >
          <Header
            style={{
              padding: 0,
              background: colorBgContainer,
              position: 'sticky',
              top: 0,
              zIndex: 999,
              width: '100%',
            }}
          >
            <Flex
              vertical={false}
              align="center"
              justify="space-between"
              gap={'large'}
            >
              <Space>
                <Button
                  type="primary"
                  shape="circle"
                  icon={
                    collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                  }
                  onClick={() => setCollapsed(!collapsed)}
                  style={{ margin: '16px' }}
                />
                <Button
                  type="default"
                  icon={<LeftOutlined />}
                  onClick={handleGoBack}
                >
                  Volver
                </Button>
                <h2 style={{ margin: 0 }}>{currentMenuLabel}</h2>
              </Space>
              <Space>
                <Tooltip title={userdata.first_name + ' ' + userdata.last_name}>
                  <Avatar icon={<UserOutlined />} />
                </Tooltip>
                <Tooltip title="Cerrar Sesion">
                  <Button
                    shape="circle"
                    type="primary"
                    title="Cerrar Sesion"
                    icon={<LogoutOutlined />}
                    style={{ marginRight: 20 }}
                    onClick={cerrarSesion}
                  />
                </Tooltip>
              </Space>
            </Flex>
          </Header>
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: 4,
            }}
          >
            {props.children}
          </Content>
          <Footer
            style={{
              textAlign: 'center',
              padding: '20px',
            }}
          >
            ©{moment().format('YYYY')}
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};
export default Layouts;
